<style>
  .mat-sidenav {
    position: fixed;
  }

  .mat-mdc-list-item {
    font-size: 10px;
  }

  .mat-mdc-nav-list {
    font-size: 11px;
  }

  @media (max-width: 549px) {

    .mobile-sidenav {
      width: 100vw !important;
      max-width: 100vw !important;
    }

    .mobile-sidenav .mat-mdc-list-item {
      width: 100% !important;
      justify-content: flex-start !important;

      padding: 0 12px !important;
      height: 46px !important;

      font-size: 13px !important;
    }

    .mobile-sidenav .mat-icon {
      font-size: 20px !important;
      width: 20px !important;
      height: 20px !important;
    }

    .mobile-sidenav hr {
      width: 90%;
      margin: 8px auto;
      border-color: rgba(255, 255, 255, 0.15);
    }
  }

  .avatar-menu.mat-mdc-menu-panel {
    min-width: 240px !important;
    overflow: hidden !important;
    border-radius: 16px !important;
    background: #ffffff !important;
    border: 1px solid #000000 !important;
    box-shadow: none !important;
  }

  .avatar-menu .mat-mdc-menu-content {
    padding: 0 !important;
  }

  summary::-webkit-details-marker {
    display: none;
  }

  summary {
    list-style: none;
  }

.submenu-arrow {
    position: absolute;
    right: -2px;
    top: -2px;
    z-index: 2;
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    line-height: 16px !important;
    pointer-events: none;
  }

  .dashboard-menu-anchor,
  .generate-content-menu-anchor {
    position: absolute !important;
    inset: 0 !important;
    z-index: 3 !important;
    width: 48px !important;
    height: 48px !important;
    opacity: 0 !important;
  }

</style>


<ng-container *ngIf="isLoggedIn; else loggedOut">
  <mat-sidenav-container>
    <mat-sidenav #drawer [class.opened]="opened" [mode]="isSmallScreen ? 'over' : 'side'"
      [opened]="isSmallScreen ? false : true" [style.width.px]="opened ? 72 : 200"
      class="mobile-sidenav fixed inset-y-0 left-0 h-screen min-h-screen !bg-gray-200 overflow-hidden overflow-x-hidden"
      style="background:#333131;">
      <div class="h-full flex flex-col">

        <div class="grid grid-cols-12 items-center py-3 px-2 border-b border-gray-300" style="background:#333131;">

          <div class="col-span-11 flex justify-center">
            <a routerLink="/dashboard" class="block">
              <img *ngIf="!opened && !isSmallScreen" src="assets/images/publio_logo_bg_trans_text.png" alt="Logo"
                class="w-auto" />

              <div *ngIf="opened && !isSmallScreen" class="h-16 w-16 overflow-hidden rounded-md">
                <img src="assets/images/publio_logo_trans_bg.png" alt="Logo"
                  class="h-full w-full object-cover scale-150" />
              </div>

              <img *ngIf="isSmallScreen" src="assets/images/publio_logo_bg_trans_text.png" alt="Logo"
                class="h-24 w-auto" />
            </a>
          </div>

          <div class="col-span-1 flex justify-end">
            <button *ngIf="isSmallScreen" mat-icon-button (click)="drawer.close()" class="!text-white">
              <mat-icon>close</mat-icon>
            </button>
          </div>

        </div>

        <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden flex flex-col py-1"
          [ngClass]="isSmallScreen ? '' : 'items-center'">
          <mat-nav-list>
            <!-- SECTION: MAIN -->
            <div *ngIf="!opened || isSmallScreen"
                 class="w-full pl-5 pr-4 pt-3 pb-1 text-[10px] font-medium uppercase tracking-[0.08em] text-gray-500 section-label"
                 [ngClass]="{'hidden': opened && !isSmallScreen}">
              Main
            </div>

            <!-- DASHBOARD ACCORDION -->
            <div class="w-full">
              <ng-container *ngIf="!opened; else miniDashboard">

                <!-- toggle -->
                <input #menuDashboard type="checkbox" id="menu-dashboard" class="peer hidden"
                  [checked]="isDashboardRoute" />

                <label for="menu-dashboard">
                  <a mat-list-item class="mt-1 cursor-pointer"
                    [ngClass]="'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
                    <mat-icon matListItemIcon class="text-[24px]">
                      dashboard
                    </mat-icon>

                    <div class="ml-auto flex items-center gap-1">
                      <span class="label leading-none">Dashboard</span>

                      <mat-icon *ngIf="!opened" class="text-[20px] leading-none dash-arrow">
                        expand_more
                      </mat-icon>


                    </div>
                  </a>
                </label>

                <!-- dropdown -->
                <div class="max-h-0 overflow-hidden transition-all duration-300 peer-checked:max-h-55">
                  <div class="pl-6 flex flex-col">

                    <a mat-list-item routerLink="/dashboard/followers" routerLinkActive="active" class="!h-9 text-xs">
                      Follower Growth
                    </a>

                    <a mat-list-item routerLink="/dashboard/format" routerLinkActive="active" class="!h-9 text-xs">
                      Format Breakdown
                    </a>

                    <a mat-list-item routerLink="/dashboard/trends" routerLinkActive="active" class="!h-9 text-xs">
                      Trends
                    </a>

                    <a mat-list-item routerLink="/dashboard/heatmap" routerLinkActive="active" class="!h-9 text-xs">
                      Heatmap
                    </a>

                    <a mat-list-item routerLink="/dashboard/alerts" routerLinkActive="active" class="!h-9 text-xs">
                      Alerts
                    </a>

                  </div>
                </div>
              </ng-container>

              <!-- MINI SIDEBAR -->
              <ng-template #miniDashboard>
                <a mat-list-item class="mt-1 cursor-pointer" (click)="openDashboardMenu($event)" matTooltip="Dashboard"
                  matTooltipPosition="right" [ngClass]="
                  'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors relative'
                ">
                  <mat-icon matListItemIcon class="text-[24px] leading-none">
                    dashboard
                  </mat-icon>

                  <mat-icon class="submenu-arrow">
                    {{ dashboardMenuTrigger.menuOpen ? 'chevron_right' : 'expand_less' }}
                  </mat-icon>

                  <button mat-icon-button #dashboardMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="dashboardMenu"
                    class="dashboard-menu-anchor">
                    <mat-icon>dashboard</mat-icon>
                  </button>
                </a>
              </ng-template>

            </div>

            <mat-menu #dashboardMenu="matMenu" xPosition="after" yPosition="below" class="compact-menu" style="font-size: 13px;">

              <button mat-menu-item [routerLink]="'/dashboard/followers'">
                Follower Growth
              </button>

              <button mat-menu-item [routerLink]="'/dashboard/format'">
                Format Breakdown
              </button>

              <button mat-menu-item [routerLink]="'/dashboard/trends'">
                Trends
              </button>

              <button mat-menu-item [routerLink]="'/dashboard/heatmap'">
                Heatmap
              </button>

              <button mat-menu-item [routerLink]="'/dashboard/alerts'">
                Alerts
              </button>
            </mat-menu>

            <!-- SECTION: CONTENT -->
            <div *ngIf="!opened || isSmallScreen"
                 class="w-full pl-5 pr-4 pt-3 pb-1 text-[10px] font-medium uppercase tracking-[0.08em] text-gray-500 mt-2 section-label"
                 [ngClass]="{'hidden': opened && !isSmallScreen}">
              Content
            </div>

            <a mat-list-item routerLink="/create-post" class="mt-1" routerLinkActive="active"
              [matTooltip]="opened ? 'New Posts' : ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon
                [ngClass]="opened ? 'text-[28px] leading-none' : 'text-[24px] leading-none'">mode_edit</mat-icon>
              <span class="label">Create Post</span>
            </a>

            <a mat-list-item routerLink="/posts" class="mt-1" routerLinkActive="active"
              [matTooltip]="opened ? 'General Posts' : ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon
                [ngClass]="opened ? 'text-[28px] leading-none' : 'text-[24px] leading-none'">view_list</mat-icon>
              <span class="label">View Posts</span>
            </a>

            <a mat-list-item routerLink="/repeat-posts" class="mt-1" routerLinkActive="active"
              [matTooltip]="opened ? 'Repeated Posts' : ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon
                [ngClass]="opened ? 'text-[28px] leading-none' : 'text-[24px] leading-none'">repeat</mat-icon>
              <span class="label">Repeated Posts</span>
            </a>

            <!-- SECTION: INTELLIGENCE -->
            <div *ngIf="!opened || isSmallScreen"
                 class="w-full pl-5 pr-4 pt-3 pb-1 text-[10px] font-medium uppercase tracking-[0.08em] text-gray-500 mt-2 section-label"
                 [ngClass]="{'hidden': opened && !isSmallScreen}">
              Intelligence
            </div>

            <!-- PerceptionIQ -->
            <a *ngIf="userRole === 'Admin'" mat-list-item routerLink="/perception-iq" class="mt-1" routerLinkActive="active"
              [matTooltip]="opened ? 'PerceptionIQ' : ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon
                [ngClass]="opened ? 'text-[28px] leading-none' : 'text-[24px] leading-none'">insights</mat-icon>
              <span class="label">PerceptionIQ</span>
            </a>

            <!-- Hiding AI Engine option as it doesn't work -->
            <!-- <a mat-list-item routerLink="/pages/ai-engine/new-content" routerLinkActive="active"
              [matTooltip]="opened ? 'AI Engine' : ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon
                [ngClass]="opened ? 'text-[28px] leading-none' : 'text-[24px] leading-none'">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12.983 21.186a1 1 0 0 1-1.966 0 10 10 0 0 0-8.203-8.203 1 1 0 0 1 0-1.966 10 10 0 0 0 8.203-8.203 1 1 0 0 1 1.966 0 10 10 0 0 0 8.203 8.203 1 1 0 0 1 0 1.966 10 10 0 0 0-8.203 8.203"></path>
                </svg>
              </mat-icon>
              <span class="label">AI Engine</span>
            </a> -->

            <a mat-list-item routerLink="/reports-metrics" class="mt-1" routerLinkActive="active"
              [matTooltip]="opened ? 'Reports' : ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon
                [ngClass]="opened ? 'text-[28px] leading-none' : 'text-[24px] leading-none'">book</mat-icon>
              <span class="label">Reports</span>
            </a>

            <!-- SECTION: BULK OPERATIONS -->
            <div *ngIf="!opened || isSmallScreen"
                 class="w-full pl-5 pr-4 pt-3 pb-1 text-[10px] font-medium uppercase tracking-[0.08em] text-gray-500 mt-2 section-label"
                 [ngClass]="{'hidden': opened && !isSmallScreen}">
              Bulk Operations
            </div>

            <a mat-list-item routerLink="/bulk-upload" class="mt-1" routerLinkActive="active"
              [matTooltip]="opened ? 'Upload Bulk' : ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon
                [ngClass]="opened ? 'text-[28px] leading-none' : 'text-[24px] leading-none'">cloud_upload</mat-icon>
              <span class="label">Upload Bulk</span>
            </a>

            <a mat-list-item routerLink="/bulk-posts" class="mt-1" routerLinkActive="active"
              [matTooltip]="opened ? 'Bulk Posts': ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon
                [ngClass]="opened ? 'text-[28px] leading-none' : 'text-[24px] leading-none'">post_add</mat-icon>
              <span class="label">View Bulks</span>
            </a>

            <!-- SECTION: ACCOUNT -->
            <div *ngIf="!opened || isSmallScreen"
                 class="w-full pl-5 pr-4 pt-3 pb-1 text-[10px] font-medium uppercase tracking-[0.08em] text-gray-500 mt-2 section-label"
                 [ngClass]="{'hidden': opened && !isSmallScreen}">
              Account
            </div>

            <a mat-list-item routerLink="/social-ai" class="mt-1" routerLinkActive="active"
              [matTooltip]="opened ? 'Settings' : ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon
                [ngClass]="opened ? 'text-[28px] leading-none' : 'text-[24px] leading-none'">settings</mat-icon>
              <span class="label">Settings</span>
            </a>

            <!-- SECTION: ADMIN (only visible for Admin users) -->
            <div *ngIf="(userRole === 'Admin') && (!opened || isSmallScreen)"
                 class="w-full pl-5 pr-4 pt-3 pb-1 text-[10px] font-medium uppercase tracking-[0.08em] text-gray-500 mt-2 section-label"
                 [ngClass]="{'hidden': opened && !isSmallScreen}">
              Admin
            </div>

            <a *ngIf="userRole === 'Admin'" mat-list-item routerLink="/social-ai-admin"
              class="mt-1 text-red-600 hover:text-red-800" routerLinkActive="active"
              [matTooltip]="opened ? 'Create Account' : ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon [ngClass]="opened
                ? '!text-red-500 text-[28px]'
                : 'text-gray-500 text-[24px]'">
                admin_panel_settings
              </mat-icon>
              <span class="label text-red-600">Create Account</span>
            </a>

            <a *ngIf="userRole === 'Admin'" mat-list-item routerLink="/company" class="mt-1" routerLinkActive="active"
              [matTooltip]="opened ? 'View Accounts' : ''" matTooltipPosition="right"
              [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
              <mat-icon matListItemIcon
                [ngClass]="opened ? '!text-red-500 text-[28px] leading-none' : 'text-[24px] leading-none'">article</mat-icon>
              <span class="label text-red-600">View Accounts</span>
            </a>

            <!-- commented ONLY FOR NOW -->
            <!-- only for development enviroment -->
            <!-- <div *ngIf="isDev">
              <hr class="my-4">
              <a *ngIf="userRole === 'Admin'" mat-list-item routerLink="manage-account/create-company"
                class="mt-2 text-red-600 hover:text-red-800" routerLinkActive="active"
                [matTooltip]="opened ? 'Create Account' : ''" matTooltipPosition="right"
                [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-2 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-1 h-11 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
                -
                <span class="label text-red-600">Create Flow (*)</span>
              </a> -->

              <!-- <a *ngIf="userRole === 'Admin'" mat-list-item routerLink="/leonardo-ai/old"
                class="mt-2 text-red-600 hover:text-red-800" routerLinkActive="active"
                [matTooltip]="opened ? 'Create Account' : ''" matTooltipPosition="right"
                [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-2 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-1 h-11 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
                -
                <span class="label text-red-600">Leonardo AI (*)</span>
              </a> -->

              <!-- <a *ngIf="userRole === 'Admin'" mat-list-item routerLink="/manage-application" class="mt-2"
                routerLinkActive="active" [matTooltip]="opened ? 'Manage Application' : ''" matTooltipPosition="right"
                [ngClass]="opened
              ? 'w-12 h-12 mx-auto my-2 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
              : 'w-full my-1 h-11 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
                <mat-icon matListItemIcon
                  [ngClass]="opened ? '!text-red-500 text-[28px] leading-none' : 'text-[24px] leading-none'">settings_applications</mat-icon>
                <span class="label text-red-600">Manage Application</span>
              </a>
            </div> -->
          </mat-nav-list>

        </div>
        <!-- Logout in sidebar / minisidebar -->
        <a mat-list-item class="mt-1 text-red-600 hover:text-red-800 cursor-pointer" (click)="logout()"
          [matTooltip]="opened ? 'Return to Cloud' : ''" matTooltipPosition="right" [ngClass]="opened
        ? 'w-12 h-12 mx-auto my-0 rounded-full flex items-center justify-center !p-0 hover:bg-white/10 transition-colors'
        : 'w-full my-0 h-10 rounded-full px-3 flex items-center gap-3 hover:bg-black/5 transition-colors box-border'">
          <mat-icon matListItemIcon
            [ngClass]="opened ? '!text-red-500 text-[28px] leading-none' : 'text-[24px] leading-none'">
            logout
          </mat-icon>
          <span class="label text-red-600">Return to Cloud</span>
        </a>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="flex min-h-screen" [style.margin-left.px]="isSmallScreen ? 0 : (opened ? 72 : 200)">
      <mat-toolbar class="flex flex-row gap-4">

        <button mat-icon-button (click)="isSmallScreen ? drawer.toggle() : toggleDrawer()" class="!bg-gray-200">
          <mat-icon> {{ isSmallScreen ? 'menu' : (opened ? 'menu' : 'menu_open') }} </mat-icon>
        </button>

        <span class="toolbar-title">
          Publio.ai
          <div class="text-xs">{{ user.companyName }}</div>
        </span>
        <div class="flex flex-grow"></div>

        <div class="relative flex items-center gap-2">
          <details class="group relative">
            <summary
              (click)="perceptionIqNotificationService.markAllAsRead()"
              aria-label="Notifications"
              class="relative flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-gray-200 text-gray-700 transition hover:bg-gray-300">
              <mat-icon class="!text-[22px]">
                notifications
              </mat-icon>

              <span
                *ngIf="(perceptionIqNotificationService.unreadCount$ | async) as unreadCount"
                class="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-bold leading-none text-white">
                {{ unreadCount > 9 ? '9+' : unreadCount }}
              </span>
            </summary>

            <div
              class="absolute right-0 top-12 z-50 w-[360px] max-w-[calc(100vw-24px)] overflow-hidden rounded-xl border border-gray-300 bg-white shadow-lg">
              <div class="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-4 py-3">
                <div>
                  <p class="text-sm font-semibold text-gray-900">
                    Notifications
                  </p>
                </div>

                <button
                  *ngIf="(perceptionIqNotificationService.notifications$ | async)?.length"
                  type="button"
                  (click)="perceptionIqNotificationService.clearAll()"
                  class="text-xs font-semibold text-[var(--piq-primary-indigo)] hover:underline">
                  Clear all
                </button>
              </div>

              <ng-container
                *ngIf="perceptionIqNotificationService.notifications$ | async as notifications">
                <div
                  *ngIf="notifications.length > 0; else noNotifications"
                  class="max-h-[360px] overflow-y-auto">
                  <button
                    *ngFor="let notification of notifications"
                    type="button"
                    (click)="perceptionIqNotificationService.openNotification(notification)"
                    class="flex w-full items-start gap-3 border-b border-gray-100 px-4 py-3 text-left transition hover:bg-gray-50"
                    [ngClass]="{
                      'bg-indigo-50/60': !notification.read
                    }">
                    <div
                      class="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full"
                      [ngClass]="{
                        'bg-emerald-100 text-emerald-700':
                          notification.type === 'completed',
                        'bg-red-100 text-red-700':
                          notification.type === 'failed'
                      }">
                      <mat-icon class="!h-5 !w-5 !text-[20px] !leading-5">
                        {{
                          notification.type === 'completed'
                            ? 'description'
                            : 'error_outline'
                        }}
                      </mat-icon>
                    </div>

                    <div class="min-w-0 flex-1">
                      <div class="flex items-start justify-between gap-2">
                        <p class="text-sm font-semibold text-gray-900">
                          {{ notification.title }}
                        </p>

                        <span
                          *ngIf="!notification.read"
                          class="mt-1 h-2 w-2 shrink-0 rounded-full bg-red-600">
                        </span>
                      </div>

                      <p class="mt-1 text-xs leading-5 text-gray-600">
                        {{ notification.message }}
                      </p>

                      <p class="mt-1 text-[11px] text-gray-400">
                        {{
                          notification.createdAt
                            | date:'dd MMM yyyy, HH:mm'
                        }}
                      </p>

                      <p
                        *ngIf="notification.type === 'completed'"
                        class="mt-2 text-xs font-semibold text-[var(--piq-primary-indigo)]">
                        View report
                      </p>
                    </div>
                  </button>
                </div>

                <ng-template #noNotifications>
                  <div class="px-6 py-10 text-center">
                    <mat-icon class="!h-10 !w-10 !text-[40px] !leading-10 text-gray-300">
                      notifications_none
                    </mat-icon>

                    <p class="mt-2 text-sm font-semibold text-gray-700">
                      No notifications
                    </p>
                  </div>
                </ng-template>
              </ng-container>
            </div>
          </details>

          <details class="group relative">
            <summary
              class="relative flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-gray-200 text-gray-700 transition hover:bg-gray-300">
              <mat-icon class="!text-[22px]">person</mat-icon>

              <span *ngIf="isSmallScreen"
                class="absolute -bottom-7 right-0 whitespace-nowrap text-[10px] text-gray-300">
                {{ user.Email }}
              </span>
            </summary>

            <div
              class="absolute right-0 top-12 z-50 w-max min-w-[240px] max-w-[calc(100vw-24px)] overflow-hidden rounded-xl border border-gray-300 bg-white">
              <div class="border-b border-gray-200 bg-gray-50 px-3 py-2.5">
                <p class="text-[12px] font-semibold uppercase tracking-[0.14em] text-gray-400">
                  Account
                </p>

                <p class="mt-1 whitespace-nowrap text-sm font-semibold leading-5 text-gray-900">
                  {{ user.Email }}
                </p>
              </div>

              <div class="px-3 py-2.5">
                <p class="text-[12px] font-medium leading-4 text-gray-500">
                  User ID
                </p>

                <p class="mt-0.5 text-sm font-semibold leading-5 text-gray-900">
                  {{ user.userID }}
                </p>
              </div>

              <div class="border-t border-gray-200 px-3 py-2.5">
                <p class="text-[12px] font-medium leading-4 text-gray-500">
                  Role
                </p>

                <p class="mt-0.5 text-sm font-semibold leading-5 text-gray-900">
                  {{ user.userGroup }}
                </p>
              </div>

              <div class="border-t border-gray-200 px-3 py-2.5">
                <p class="text-[12px] font-medium leading-4 text-gray-500">
                  Company
                </p>

                <p class="mt-0.5 whitespace-nowrap text-sm font-semibold leading-5 text-gray-900">
                  {{ user.companyName }}
                </p>
              </div>

              <div class="border-t border-gray-200 bg-gray-50 p-1.5">
                <button type="button" (click)="logout()"
                  class="flex h-9 w-full items-center gap-2 rounded-lg px-2.5 text-left text-red-600 transition hover:bg-red-50">
                  <mat-icon class="!text-[18px] !text-red-600">logout</mat-icon>

                  <span class="text-sm font-semibold leading-none text-red-600">
                    Return to Cloud
                  </span>
                </button>
              </div>
            </div>
          </details>
        </div>

      </mat-toolbar>

      <div class="p-2">
        <router-outlet></router-outlet>
      </div>

    </mat-sidenav-content>
  </mat-sidenav-container>

</ng-container>

<!-- When NOT logged in: (LoginComponent) -->
<ng-template #loggedOut>
  <router-outlet></router-outlet>
</ng-template>